import { Loading } from '@piggybank/core';
import T from 'prop-types';
import React, { Suspense, lazy, useMemo } from 'react';
import { connect } from 'react-redux';
import { retry } from './retry';
import { navigationActions } from './state/actions';
import { navigationSelectors, segmentConfigSelectors } from './state/selectors';

export const Segment = ({
  currentSegmentName,
  goToNextSegment,
  goToPrevSegment,
  ...props
}) => {
  const CurrentSegmentComponent = useMemo(
    () =>
      lazy(() =>
        retry(() =>
          import(
            /* webpackInclude: /segments[\/\\][a-z]+[\/\\]index\.js$/ */
            /* webpackChunkName: "segment.[request]" */
            /* webpackMode: "lazy" */
            `../segments/${currentSegmentName}`
          )
        )
      ),
    [currentSegmentName]
  );

  return (
    <Suspense fallback={<Loading show={true} />}>
      <CurrentSegmentComponent
        currentSegmentName={currentSegmentName}
        goToNextSegment={data => goToNextSegment(data)}
        goToPrevSegment={() => goToPrevSegment()}
        {...props}
      />
    </Suspense>
  );
};

Segment.propTypes = {
  appConfig: T.object.isRequired,
  currentSegmentName: T.string.isRequired,
  currentSegmentConfig: T.object.isRequired,
  goToNextSegment: T.func.isRequired,
  goToPrevSegment: T.func.isRequired,
  setError: T.func.isRequired,
};

export default connect(
  (state, ...ownProps) => ({
    ...ownProps,
    currentPageIndex: navigationSelectors.getCurrentPageIndex(state),
    currentSegmentConfig: segmentConfigSelectors.getCurrentSegmentConfig(state),
    currentSegmentName: segmentConfigSelectors.getCurrentSegmentName(state),
  }),
  dispatch => ({
    goToNextSegment(currentSegmentName, data, sessionId) {
      return dispatch(
        navigationActions.nextSegment(currentSegmentName, data, sessionId)
      );
    },
    goToPrevSegment(currentSegmentName, data) {
      return dispatch(navigationActions.prevSegment(currentSegmentName, data));
    },
  }),
  (stateProps, dispatchProps, ownProps = {}) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    goToNextSegment(data = null) {
      return dispatchProps.goToNextSegment(
        stateProps.currentSegmentName,
        data,
        stateProps.sessionId
      );
    },
    goToPrevSegment(data = null) {
      return dispatchProps.goToPrevSegment(stateProps.currentSegmentName, data);
    },
  })
)(Segment);
